import { BALANCE } from '../config/balance';
import type { RngStream } from '../core/rng';
import { dist, normalize } from '../core/vec';
import type { Player } from './player';

/** 金币：掉落 / 吸附规则同宝石；用于三选一 reroll。 */
export interface Coin {
  active: boolean;
  x: number;
  y: number;
  prevX: number;
  prevY: number;
  vx: number;
  vy: number;
  value: number;
  flying: boolean;
}

export function createCoin(): Coin {
  return {
    active: false,
    x: 0, y: 0, prevX: 0, prevY: 0,
    vx: 0, vy: 0, value: 1, flying: false,
  };
}

/** 掉落：drops 流给弹出方向；amount 已含贪婪乘数（取整）。 */
export function spawnCoin(
  c: Coin,
  x: number,
  y: number,
  amount: number,
  rng: RngStream,
): void {
  const g = BALANCE.gold;
  const a = rng.range(0, Math.PI * 2);
  const sp = rng.range(g.popSpeedMin, g.popSpeedMax);
  c.active = true;
  c.x = x; c.y = y;
  c.prevX = x; c.prevY = y;
  c.vx = Math.cos(a) * sp;
  c.vy = Math.sin(a) * sp;
  c.value = Math.max(1, Math.round(amount));
  c.flying = false;
}

/** 更新金币；返回 true 表示被拾取。 */
export function updateCoin(c: Coin, dt: number, player: Player): boolean {
  const g = BALANCE.gold;
  c.prevX = c.x;
  c.prevY = c.y;

  if (!c.flying) {
    c.x += c.vx * dt;
    c.y += c.vy * dt;
    const d = Math.exp(-g.popDamp * dt);
    c.vx *= d;
    c.vy *= d;
    if (dist(c.x, c.y, player.x, player.y) < player.stats.pickupRadius) {
      c.flying = true;
      c.vx = 0; c.vy = 0;
    }
    return false;
  }

  const n = normalize(player.x - c.x, player.y - c.y);
  const sp = Math.min(g.flyMaxSpeed, Math.hypot(c.vx, c.vy) + g.flyAccel * dt);
  c.vx = n.x * sp;
  c.vy = n.y * sp;
  c.x += c.vx * dt;
  c.y += c.vy * dt;
  return dist(c.x, c.y, player.x, player.y) < BALANCE.player.radius + 7;
}
